import * as yup from 'yup'
import { TYPE_REQUIRED, TYPE_EMAIL_INVALID } from 'constants/errors'

export default yup.object().shape({
  email: yup.string().email(TYPE_EMAIL_INVALID).required(TYPE_REQUIRED),
})
